export default __webpack_public_path__ + "static/media/bank-footer-logo.8e59d761.svg";